import { Key } from 'lucide-react';

import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { SortableHeader } from '@/components/ui/data-table';

import { formatDate } from '@/lib/date';

import { ApiKeyActionsCell, ApiKeyValueCell } from './api-key-cell';
import { RowAction } from './row-action';

import type { ApiKey } from '@/types/api-key.type';
import type { ColumnDef } from '@tanstack/react-table';

export const getColumns = (): ColumnDef<ApiKey>[] => [
  {
    id: 'secret_name',
    accessorKey: 'secret_name',
    header: ({ column }) => <SortableHeader label="Name" column={column} />,
    cell: ({ row }) => (
      <div className="flex items-center gap-3">
        <Avatar className="h-7 w-7">
          <AvatarFallback className="bg-primary text-primary-foreground">
            <Key className="h-3.5 w-3.5" />
          </AvatarFallback>
        </Avatar>
        <span className="font-medium text-foreground">{row.original.secret_name}</span>
      </div>
    ),
  },
  {
    id: 'secret_value',
    accessorKey: 'secret_value',
    header: 'Key value',
    cell: ({ row }) => <ApiKeyValueCell id={row.original.id} apiKey={row.original.secret_value} />,
  },
  {
    id: 'reveal_copy',
    header: 'Reveal / Copy',
    enableSorting: false,
    cell: ({ row }) => (
      <ApiKeyActionsCell id={row.original.id} apiKey={row.original.secret_value} />
    ),
  },
  {
    id: 'creator_user',
    header: ({ column }) => <SortableHeader label="Created by" column={column} />,
    cell: ({ row }) => (
      <span className="text-foreground">{row.original.creator_user.full_name}</span>
    ),
  },
  {
    id: 'created_at',
    accessorKey: 'created_at',
    header: ({ column }) => <SortableHeader label="Created at" column={column} />,
    cell: ({ getValue }) => (
      <span className="text-foreground">{formatDate(getValue() as string)}</span>
    ),
  },
  {
    id: 'actions',
    enableSorting: false,
    cell: ({ row }) => <RowAction apiKey={row.original} />,
  },
];
